import React from 'react'
import PropTypes from 'prop-types'
import { capitalize } from '../../../../../../utils/string'

const InitialNodeTooltip = ({ activeNode, visibility, x, y }) => {
  const style = {
    left: `${x}px`,
    top: `${y}px`,
    visibility,
  }
  return (
    <div>
      {activeNode.skills && activeNode.skills.length > 0 &&
        <div id="InitialNodeTooltip" className="wheel-tooltip shadow text-center" style={style}>
          <h6 style={{marginBottom: 2, textAlign: 'center'}}>
            Skills
          </h6>
          <h5 style={{textAlign: 'center', margin: 0}}>
            {activeNode.skills &&
             activeNode.skills.map((skill, index) => index === activeNode.skills.length - 1 ? `${capitalize(skill)}` : `${capitalize(skill)}, `)
            }
          </h5>
        </div>
      }
    </div>
  )
}

InitialNodeTooltip.propTypes = {
  activeNode: PropTypes.object,
  visibility: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
}

export default InitialNodeTooltip



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/InitialNodeTooltip.js